import { useState, useCallback } from 'react';
import {
  type TraumatologiaData,
  emptyTraumatologiaData,
} from './types';

export const useTraumatologiaForm = () => {
  const [traumatologiaData, setTraumatologiaData] = useState<TraumatologiaData>(emptyTraumatologiaData);

  const setTraumatologiaField = useCallback(
    (section: keyof TraumatologiaData, field: string, value: any) => {
      setTraumatologiaData(prev => ({
        ...prev,
        [section]: {
          ...(prev[section] as any),
          [field]: value,
        },
      }));
    },
    [],
  );

  const loadFromConsultation = (rawData: any) => {
    const raw = (rawData as any)?.traumatologia;
    if (!raw) return;

    const parsed: TraumatologiaData = {
      ...emptyTraumatologiaData,
      ...raw,
      fracture: { ...emptyTraumatologiaData.fracture, ...(raw.fracture || {}) },
      injury_mechanism: { ...emptyTraumatologiaData.injury_mechanism, ...(raw.injury_mechanism || {}) },
      neurovascular_exam: { ...emptyTraumatologiaData.neurovascular_exam, ...(raw.neurovascular_exam || {}) },
      physical_exam_trauma: { ...emptyTraumatologiaData.physical_exam_trauma, ...(raw.physical_exam_trauma || {}) },
      imaging: { ...emptyTraumatologiaData.imaging, ...(raw.imaging || {}) },
      treatment: { ...emptyTraumatologiaData.treatment, ...(raw.treatment || {}) },
      complications: { ...emptyTraumatologiaData.complications, ...(raw.complications || {}) },
    };

    setTraumatologiaData(parsed);
  };

  const getPayloadData = (): TraumatologiaData | null => {
    const hasData =
      traumatologiaData.fracture.type !== '' ||
      traumatologiaData.injury_mechanism.mechanism !== '' ||
      traumatologiaData.neurovascular_exam.motor_function !== '' ||
      traumatologiaData.physical_exam_trauma.edema !== '' ||
      traumatologiaData.imaging.xray_findings !== '' ||
      traumatologiaData.treatment.type !== '' ||
      traumatologiaData.complications.other !== '';
    return hasData ? traumatologiaData : null;
  };

  return {
    traumatologiaData,
    setTraumatologiaData,
    setTraumatologiaField,
    loadFromConsultation,
    getPayloadData,
  };
};
